import { SmartfireComponent, smartProps } from '@smartfire/gutenberg-react';
import React from 'react';
import './style.scss';
import BlocklistMiniatureBlock from '../blocklist-miniature-block/block.js';
import BlocklistDetailsBlock from '../blocklist-details-block/block.js';
import BlocklistPlacholderBlock from '../blocklist-placeholder-block/block.js';
import chunk from 'lodash.chunk';

export default class Blocklist extends SmartfireComponent {
    static smartProps = {
        sectionTitle: smartProps.any.withDefault(''),
        showProjectPlacholder: smartProps.any.withDefault(false),
    };

    constructor(props) {
        super(props);
        this.state = {
            openedBlockId: -1,
            rowMaxSizes: {
                desktop: 4,
                'desktop-small': 3,
                tablet: 2,
                mobile: 1,
            },
        };
        this.detailsRef = [];
    }

    componentDidMount() {
        this.updateDimensions();
        window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    getSliderSize() {
        if (this.state.rowMaxSizes[this.state.currentSize] < this.props.itemsPerRow)
            return this.state.rowMaxSizes[this.state.currentSize];
        else return this.props.itemsPerRow;
    }

    updateDimensions = () => {
        if (window.matchMedia('(min-width: 1450px)').matches) {
            this.setState({ currentSize: 'desktop' });
        } else if (window.matchMedia('(min-width: 1025px)').matches) {
            this.setState({ currentSize: 'desktop-small' });
        } else if (window.matchMedia('(min-width: 768px)').matches) {
            this.setState({ currentSize: 'tablet' });
        } else {
            this.setState({ currentSize: 'mobile' });
        }
    };

    openDetails = (index) => {
        if (index === this.state.openedBlockId) {
            this.setState({ openedBlockId: -1 });
        } else if (this.state.openedBlockId > -1) {
            //if a detail box is already open, we close it before opening the new one
            this.setState({ openedBlockId: -1 });
            setTimeout(() => {
                this.setState({ openedBlockId: index });
            }, 500);
        } else {
            this.setState({ openedBlockId: index });
            this.detailsRef[index].scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        }
    };

    render() {
        let rows = this.props.blocks.map((block, i) => (
            <React.Fragment key={i}>
                <div
                    className="block"
                    onClick={() =>
                        this.props.type === 'job-offers' && this.openDetails(i)
                    }
                >
                    <BlocklistMiniatureBlock
                        type={this.props.type}
                        url={block.buttons ? block.buttons[0].url : block.url}
                        image={block.image}
                        title={block.title}
                        description={block.shortDescription}
                        showSlideButton={this.props.showSlideButton}
                    />
                </div>
                {this.props.type === 'job-offers' && (
                    <div
                        ref={(ref) => {
                            this.detailsRef[i] = ref;
                            return true;
                        }}
                        className={
                            'details ' + (this.state.openedBlockId === i ? 'show' : '')
                        }
                    >
                        <BlocklistDetailsBlock
                            type={this.props.type}
                            id={block.ID}
                            title={block.title}
                            longDescription={block.longDescription}
                            columns={block.columns}
                            buttons={block.buttons}
                            descriptionImage={block.descriptionImage}
                        />
                    </div>
                )}
            </React.Fragment>
        ));

        if (rows.length % this.getSliderSize() !== 0) {
            rows.push(
                <React.Fragment key={rows.length}>
                    <div className={`block placeholder`}>
                        <BlocklistPlacholderBlock phone={this.props.phone} />
                    </div>
                </React.Fragment>,
            );
        }

        let finalRows = chunk(rows, this.getSliderSize()).map((group) => {
            return (
                <div className={`blocks-list size-${this.state.currentSize}`}>
                    {group}
                </div>
            );
        });

        return (
            <div className={'blocklist ' + this.props.type} id={this.props.sectionTitle}>
                <div className="content-container">
                    <div className="block-container">
                        {this.props.title !== '' && (
                            <div class="title-col">
                                <p class="title-block">{this.props.title}</p>
                            </div>
                        )}
                        {finalRows}
                    </div>
                </div>
            </div>
        );
    }
}
